module.exports = __webpack_public_path__ + "img/ai-buy-fit-error.ba2ba59b.png";